// extracted by mini-css-extract-plugin
module.exports = {"list":"ThankYouPage_list__z4O17","listItemImage":"ThankYouPage_listItemImage__Qp_YN","patientManager":"ThankYouPage_patientManager__Lt2Wt"};